import { BrowserRouter, Route, Routes } from "react-router-dom";

import { AuthProvider, useAuth } from "./components/Auth";
import { FeedbackProvider } from "./components/Feedback";
import { Layout } from "./components/Layout";
import { Loading, PageHeader } from "./components/Page";
import { CustomerDetail, Customers } from "./pages/Customers";
import { DataQuality } from "./pages/DataQuality";
import { Depletions } from "./pages/Depletions";
import { DocumentDetail } from "./pages/DocumentDetail";
import { DocumentForm } from "./pages/DocumentForm";
import { Documents } from "./pages/Documents";
import { LocationDetail, Locations } from "./pages/Locations";
import { ForcePasswordChange, Login } from "./pages/Login";
import { Overview } from "./pages/Overview";
import { Production } from "./pages/Production";
import { Costs } from "./pages/Costs";
import { ProductDetail, Products } from "./pages/Products";
import { QuickBooks } from "./pages/QuickBooks";
import { InvoiceDetail, Sales } from "./pages/Sales";
import { PartyForm, Settings } from "./pages/Settings";
import { RunDetail, SourceDetail, Sources } from "./pages/Sources";
import { Stock } from "./pages/Stock";
import { Tasks } from "./pages/Tasks";
import { Shipments } from "./pages/Shipments";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <FeedbackProvider>
          <Gate />
        </FeedbackProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

/** Nothing renders — and no data is fetched — until there is a session. */
function Gate() {
  const { user, loading } = useAuth();
  if (loading) return <div className="signin"><Loading label="Loading…" /></div>;
  if (!user) return <Login />;
  if (user.must_change_password) return <ForcePasswordChange />;
  return <AppRoutes />;
}

function AppRoutes() {
  return (
    <Layout>
          <Routes>
            <Route path="/" element={<Overview />} />
            <Route path="/stock" element={<Stock />} />
            <Route path="/production" element={<Production />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/documents/new" element={<DocumentForm />} />
            <Route path="/documents/:id" element={<DocumentDetail />} />
            <Route path="/documents/:id/edit" element={<DocumentForm />} />
            <Route path="/sales" element={<Sales />} />
            <Route path="/sales/invoices/:channel/:invoice" element={<InvoiceDetail />} />
            <Route path="/depletions" element={<Depletions />} />
            <Route path="/shipments" element={<Shipments />} />
            <Route path="/quickbooks" element={<QuickBooks />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/customers/:id" element={<CustomerDetail />} />
            <Route path="/costs" element={<Costs />} />
            <Route path="/tasks" element={<Tasks />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:sku" element={<ProductDetail />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/locations/:code" element={<LocationDetail />} />
            <Route path="/data-quality" element={<DataQuality />} />
            <Route path="/sources" element={<Sources />} />
            <Route path="/sources/:code" element={<SourceDetail />} />
            <Route path="/imports/:id" element={<RunDetail />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/settings/address-book/new" element={<PartyForm />} />
            <Route path="/settings/address-book/:id" element={<PartyForm />} />
        <Route path="*" element={<PageHeader title="Page not found" sub="That address does not match anything in the app." />} />
      </Routes>
    </Layout>
  );
}
